<template>
    <div class="row mb-5 mb-md-0">
        <div class="col-12 d-md-none mb-3">{{name}}</div>

        <div class="d-flex flex-column flex-md-row">
            <div class="mr-md-3">
                <img class="thumbnail" :src="value.pictures[0].medium" alt="">
            </div>

            <div class="row">
                <div class="d-none d-md-block col-12">{{name}}</div>

                <!-- Name -->
                <div v-if="value.count && 1 < value.count" class="col-12 quantity">
                    {{t('quantity')}}: {{value.count}}
                </div>

                <!-- Tracking -->
                <div v-if="value.tracking" class="col-12 tracking">
                    {{t('tracking')}}:
                    <span v-if="value.tracking_url">
                    <a :href="value.tracking_url" target="_blank" rel="noopener">{{value.tracking}}</a>
                </span>
                    <span v-else>{{value.tracking}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import mixin_products from "@/mixins/products";

    export default {
        name: "SurveyDeliveryProduct",
        mixins: [mixin_products],
        props: {
            value: {
                type: Object,
                required: true
            }
        },
        data() {

            return {
                t_path: "components.survey.delivery.product",
            };
        },
        computed: {
            name() {

                return this.products_translateProductName(this.value);
            }
        }
    }
</script>